import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";
import { IndicatorEsbStatusEnum } from "@/utils/enums/IndicatorEsbStatusEnum";

export type ResumeCitizensGroupActivitiesIndicatorB4Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export class ResumeCitizenGroupActivitiesIndicatorB4Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";

	esbHealthTeamId: number = 0;
	esbHealthTeamIne: string = "";
	esbHealthTeamName: string = "";
	linkedHealthTeamId: number = 0;
	linkedHealthTeamIne: string = "";
	linkedHealthTeamName: string = "";
	supervisedBrushingStatus: IndicatorEsbStatusEnum = IndicatorEsbStatusEnum.Lost;
}

export async function getResumeCitizensGroupActivitiesIndicatorB4({
	uf,
	ibgeCode,
	...params
}: ResumeCitizensGroupActivitiesIndicatorB4Params) {
	const response = await esusApi.get<Paginated<ResumeCitizenGroupActivitiesIndicatorB4Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b4/resume-citizens-group-activities`,
		params
	);
	return response.data ?? new Paginated<ResumeCitizenGroupActivitiesIndicatorB4Data>();
}
